import { message } from 'antd'
import { useWindowDimensions } from 'app/hooks'
import axios from 'axios'
import { useLocation } from 'react-router-dom'

export const useCheckTradePage = () => {
	const location = useLocation()
	const urlSegments = location.pathname?.split('/')
	const hasTradeSegment = urlSegments?.some(segment =>
		segment.includes('trade')
	)
	return hasTradeSegment ? true : false
}
export const useWSize = (size?: any) => {
	const { width } = useWindowDimensions()
	const dynamicSize = size ? size : 0
	const wSize =
		width < 772
			? width / 1.2
			: width < 1400
			? width < 900
				? width / 1.5 - dynamicSize
				: width / 2 - dynamicSize
			: width / 3 - dynamicSize
	return wSize
}

export const SliderSize = () => {
	const { width } = useWindowDimensions()
	return width > 1400 ? 4 : width > 1200 ? 3 : width > 600 ? 2 : 1
}
export const WindowSize = (large: any, medium: any, small: any) => {
	const { width } = useWindowDimensions()
	return width > 900 ? large : width > 600 ? medium : small
}
export const checkEmail = email => {
	const filter = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
	if (filter) return true
	else {
		return 'NOTVALIDEMAIL'
	}
}
export const wait = timeout => {
	return new Promise(resolve => setTimeout(resolve, timeout))
}

export const apiError = (t, code) => {
	if (code === 1) {
		return t('LANG_NO_INPUT')
	} else if (code === 2) {
		return t('LANG_NO_USER')
	} else if (code === 3) {
		return t('LANG_FAIL_PASSWORD')
	} else if (code === 4) {
		return t('LANG_EXIST_USER')
	} else if (code === 5) {
		return t('LANG_NO_INPUT_EMAIL')
	} else if (code === 6) {
		return t('LANG_NO_INPUT_PHONE')
	} else if (code === 7) {
		return t('LANG_ERROR')
	} else if (code === 8) {
		return t('LANG_INVALID_REFERRAL')
	} else {
		return t('LANG_ERROR')
	}
}
export const loadData = async (number?: number) => {
	const result = await axios.get('https://api.upbit.com/v1/market/all')
	const newResult = number ? result?.data?.slice(0, number) : result?.data
	return newResult?.filter((d: any) => d.market?.match(/^KRW+/))

	// return newResult;
}
export const wSizing = (width: any, { xs, sm, md, lg }: any) => {
	return width < 768 ? xs : width < 1024 ? sm : width < 1440 ? md : lg
}

export const typeFromLevel = (level: number) => {
	switch (level) {
		case 0:
			return '신규회원'
		case 1:
			return '일반회원'
		case 2:
			return 'VIP'
		case 3:
			return 'VVIP'
		case 5:
			return '파트너회원'
		case 6:
			return '모의회원'
		case 7:
			return '페이크회원'
		case 8:
			return '운영자'
		case 9:
			return '총관리자'
		case -1:
			return '검토회원'
		case -2:
			return '거절회원'
		case -8:
			return '모의대기'
		case -9:
			return '블랙회원'
		case -10:
			return '모의블랙'
		case 99:
			return 'D'
		default:
			return '일반회원'
	}
}

export const removeHTML = (str: string) => {
	const regex = /(<([^>]+)>)/gi
	return str.replace(regex, '')
}

export const truncateText = (text, limit) => {
	if (text.length <= limit) {
		return text
	}
	const truncatedText = text.substr(0, limit).trim()
	const lastSpaceIndex = truncatedText.lastIndexOf(' ')
	if (lastSpaceIndex > -1) {
		return truncatedText.substr(0, lastSpaceIndex) + '...'
	}
	return truncatedText + '...'
}

export const beforeUpload = file => {
	const isImage = file.type.indexOf('image/') === 0
	if (!isImage) {
		message.error('You can only upload image files!')
	}
	const isLt2M = file.size / 1024 / 1024 < 10
	if (!isLt2M) {
		message.error('Image must smaller than 10MB!')
	}
	return isImage && isLt2M
}
export const anyTruthy = (...args: any[]): boolean => args.some(Boolean)
